import { Component } from '@angular/core';

@Component({
    selector: 'system-status-map',
    template: `
        <clx-status-map mode="system"></clx-status-map>
    `,
    standalone: false
})
export class SystemStatusMapComponent {

}